import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { createAndBindTedsLauncherToVue } from './app/tedsLauncher'
import { VNode } from 'vue/types/umd'
import { loadLogoComponents } from './components/Logos/loadLogoComponents'
import { bootController } from './boot'
import { installVueColor } from './app/plugins/vueColor'
import { HttpSettings } from './app/httpSettings/HttpSettings'

Vue.config.productionTip = false

function loadStyles(settings: HttpSettings) {
  const root = document.documentElement
  Object.keys(settings.app.styles).forEach(key => {
    root.style.setProperty(key, settings.app.styles[key])
  })
}

async function loadApplication(): Promise<void> {
  const state = await bootController(Vue)
  loadStyles(state.httpSettings)
  const launcher = await createAndBindTedsLauncherToVue(Vue, state)
  await launcher.mount()
  loadLogoComponents(Vue)
  installVueColor(Vue)
  new Vue({
    router,
    render: (h): VNode => h(App),
  }).$mount('#app')
}

loadApplication().catch(console.error)
